import { Pagination } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { SubmissionsMeta } from '../../StandaloneCourses/Submissions/Submissions.types';

type Props = {
	meta: SubmissionsMeta;
	page: number;
	/** rows on the current page */
	shown: number;
	onChange: (page: number) => void;
};

/** Queue pagination with "Showing x of y" beside it (page size vs. total). */
const SubmissionsPager: React.FC<Props> = ({ meta, page, shown, onChange }) => (
	<Footer>
		<Pagination
			count={Number(meta.last_page || 1)}
			page={Number(meta.current_page || page)}
			onChange={(_, value) => onChange(value)}
		/>
		<Summary>
			Showing <strong>{shown}</strong> of <strong>{Number(meta.total ?? shown)}</strong>
		</Summary>
	</Footer>
);

const Footer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5rem 1.25rem;
`;
const Summary = styled.span`
	color: #6e7577;
	font-size: 0.875rem;
	white-space: nowrap;
	strong {
		color: #251b33;
		font-weight: 600;
	}
`;

export default SubmissionsPager;
